import { EmptyState } from '@/shared/types/table';
import { cn } from '@/shared/utils/cn';
import { Button } from '@/modules/Button';
import { faSearch, faFilter, faEmptySet } from '@fortawesome/pro-regular-svg-icons';
import { Icon } from '@/modules/Icon';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { IconType } from '@/shared/types/types';

// Textos por defecto según el tipo de estado vacío
const defaultContent = {
  empty: {
    title: 'Aún no hay nada aquí...',
    description: 'Aún no hay contenido disponible por aquí para mostrar.',
  },
  'no-results': {
    title: 'No hay resultados para tu búsqueda',
    description: 'Puede probar a utilizar otras palabras clave o ajustar los filtros.',
  },
  'no-filters': {
    title: 'No hay nada aquí...',
    description: 'Puede probar ajustar los filtros.',
  },
};

export const EmptyTableState = ({
  type = 'empty',
  icon,
  title,
  description,
  action,
}: EmptyState) => {
  const getDefaultIcon = () => {
    switch (type) {
      case 'no-results':
        return faSearch;
      case 'no-filters':
        return faFilter;
      default:
        return faEmptySet;
    }
  };

  // Usar textos personalizados si se proporcionan, sino usar los por defecto
  const defaults = defaultContent[type] || defaultContent.empty;
  const displayTitle = title || defaults.title;
  const displayDescription = description ?? defaults.description;

  const containerClasses = cn(
    'ui-flex ui-min-h-[400px] ui-flex-col ui-items-center ui-justify-center ui-gap-12 ui-p-12',
  );

  return (
    <div className={containerClasses}>
      <Icon
        background
        name={(icon as IconType | IconProp) || getDefaultIcon()}
        size="xl"
        color="blue"
      />
      <div className="ui-flex ui-flex-col ui-items-center ui-gap-2 ui-text-center">
        <h3 className="ui-text-heading-h2 ui-font-heading-h2 ui-leading-heading-h2 ui-tracking-heading-h2">
          {displayTitle}
        </h3>
        {displayDescription && (
          <p className="ui-leading-body-md ui-w-full ui-text-body-md-regular ui-font-body-md-regular ui-tracking-body-md ui-text-tertiary">
            {displayDescription}
          </p>
        )}
      </div>
      {action && (
        <Button variant="button" color="primary" size="md" onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </div>
  );
};
